define.alias("shared/components/shared/button/media-uploader", "settings/components/shared/button/media-uploader");